import _defineProperty from "/codebuild/output/src3618121175/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
// Style as status component
import { prepareComponentToken, prepareToken } from '.';
import { genPresetColor, genSubStyleComponent } from '../../theme/internal';
// ============================== Preset ==============================
var genPresetStyle = function genPresetStyle(token) {
  return genPresetColor(token, function (colorKey, _ref) {
    var textColor = _ref.textColor,
      lightBorderColor = _ref.lightBorderColor,
      lightColor = _ref.lightColor,
      darkColor = _ref.darkColor;
    return _defineProperty({}, "".concat(token.componentCls).concat(token.componentCls, "-").concat(colorKey), _defineProperty({
      color: textColor,
      background: lightColor,
      borderColor: lightBorderColor,
      // Inverse color
      '&-inverse': {
        color: token.colorTextLightSolid,
        background: darkColor,
        borderColor: darkColor
      }
    }, "&".concat(token.componentCls, "-borderless"), {
      borderColor: 'transparent'
    }));
  });
};
// ============================== Export ==============================
export default genSubStyleComponent(['Tag', 'preset'], function (token) {
  var tagToken = prepareToken(token);
  return genPresetStyle(tagToken);
}, prepareComponentToken);